import { GenericCrudPage } from '@/components/GenericCrudPage';
import { examPapersConfig } from '@/pages/configs';

export default function ExamPapersPage() {
  return <GenericCrudPage config={examPapersConfig} />;
}
